import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import store from './store';
import Vuelidate from 'vuelidate';
import VueGtag from 'vue-gtag';
import router from './router/router';
import VueTour from 'vue-tour';
import VCalendar from 'v-calendar';
import VueMixpanelBrowser from 'vue-mixpanel-browser';
import './registerServiceWorker'

const mixpanelKey = process.env.VUE_APP_MIXPANEL_KEY;
Vue.use(VueMixpanelBrowser, {
  token: mixpanelKey,
  config: {
    debug:false
  }
});

// to stop from importing overwrite;
import '@/assets/css/global.css';
import '@/assets/css/video-js.css';
require('@/assets/css/vue-tour.scss');

Vue.config.productionTip = false;

// disable console log in production
const env = process.env.NODE_ENV;
// ENABLE/DISABLE Console Logs
if (env == 'production' || env == 'staging') {
  console.log = function () {};
}

Vue.use(Vuelidate);
Vue.use(VueTour);
Vue.use(VCalendar);


// router ----------------------------- //
Vue.use(VueRouter);

// analytics

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-182611101-1' },
    pageTrackerTemplate(to) {
      var googleDetails;
      let usersCurrentRoom = store.getters.getCurrentUsersRoom;
      if (usersCurrentRoom && usersCurrentRoom.topic == null) {
        googleDetails = to.name;
      } else {
        googleDetails = usersCurrentRoom && usersCurrentRoom.topic ? usersCurrentRoom.topic : 'no room';
      }
      return {
        page_title: `${store.getters.getCurrentAreaTitle} | ${googleDetails}`,
        page_path: `${store.getters.getCurrentAreaFirebaseId}${to.path}`
      };
    }
  },
  router
);

import SpaceinFramework from '@/plugins/framework.js';
Vue.use(SpaceinFramework);

// mount vue app
new Vue({
  el: '#app',
  initAPI: store.dispatch('api/initAPI'),
  router,
  store,
  render: (h) => h(App)
});

window.$$storeDebug = store;
